import { css } from '@emotion/react';

/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';

import { Link } from '@coursera/cds-core';

import { useModalContext } from './StaffPermissions/components/WithUserRoleModal';

type Props = {
  id: string | number;
};

const linkStyles = {
  root: css`
    text-align: start;
    word-break: break-word;
    color: var(--cds-color-blue-700);
  `,
};

const StaffPermissionsLink = ({ children, id }: React.PropsWithChildren<Props>) => {
  const { openModal } = useModalContext();
  return (
    <Link
      css={linkStyles.root}
      component="button"
      variant="quiet"
      onClick={() => {
        openModal(id);
      }}
    >
      {children}
    </Link>
  );
};

export default StaffPermissionsLink;
